const queryParamsRules = {
  'utms': {
    'utm_medium': {
      days: 30
    },
    'utm_source': {
      days: 30
    },
    'utm_campaign': {
      days: 30
    },
    'utm_content': {
      days: 30
    },
    'utm_term': {
      days: 30
    }
  },
  'other': {
    // 'autocoupon': {
    //   days: 1
    // },
    'document_referrer': { days: 30 } // это фейк для реактивизации куки
  }
}

export { queryParamsRules }



// WEBPACK FOOTER //
// ./src/store/modules/marketing/config.js